// Package Imports
import { z } from 'zod'

// Core Imports
import { adminListSearchSchema } from '@/core/lib/table-search-schema'

const emoteValidationErrors = {
  name: {
    required: 'Emoji ismi alanı girilmesi zorunludur',
    min: 'Emoji ismi alanı en az 2 karakter olmalıdır',
    max: 'Emoji ismi alanı en fazla 25 karakter olmalıdır',
  },
  file: {
    required: 'Resim alanı girilmesi zorunludur',
  },
}

const { name, file } = emoteValidationErrors

export const emoteSearchSchema = adminListSearchSchema

export const createEmoteSchema = z.object({
  name: z.string().min(1, name.required).min(2, name.min).max(25, name.max),
  file: z.custom<File>().refine((file) => file instanceof File, {
    message: file.required,
  }),
})

export const editEmoteSchema = z.object({
  name: z
    .string()
    .min(1, name.required)
    .min(2, name.min)
    .max(25, name.max)
    .optional(),
  file: z.custom<File>().optional(),
})
